<template>
    <div class="text-center">
        <v-bottom-sheet v-model="sheetShown" persistent inset scrollable>
            <v-card>
                <!-- >>> Stepper -->
                <v-card-text class="mt-3" style="height:800px;">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container>
                            <v-stepper v-model="formStepper" non-linear>
                                <!-- >>> Stepper: Header                     -->
                                <v-stepper-header style="position:relative;z-index:10000;">
                                    <v-stepper-step
                                        editable
                                        :rules="[ () => isValid_Stepper1 ]"
                                        step="1">
                                        Blocktime Config
                                    </v-stepper-step>
                                </v-stepper-header>
                                <!-- <<< Stepper: Header                     -->


                                <!-- >>> Stepper: 1 - 'BLocktime Config'        -->
                                <v-stepper-content ref="stepperContent1" class="pt-3" step="1">
                                    <!-- >>> Row - Personal Information -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Blocktimes</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-combobox
                                                        v-model="input_AirportDeparture"
                                                        :items="get_Airports"
                                                        item-value="aptCode"
                                                        item-text="aptCode"
                                                        :rules ="[
                                                            rules.req(input_AirportDeparture),
                                                        ]"
                                                        prepend-icon="mdi-airplane-takeoff"
                                                        clearable
                                                        @change="onChange_inputAirportDeparture">
                                                        <template v-slot:label>
                                                            <p>
                                                                Airport Departure <span style="color: red; font-size: 1.4rem;">*</span>
                                                            </p>
                                                        </template>
                                                    </v-combobox>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-combobox
                                                        v-model="input_AirportDestination"
                                                        :items="get_Airports"
                                                        item-value="aptCode"
                                                        item-text="aptCode"
                                                        :rules ="[
                                                            rules.req(input_AirportDestination),
                                                        ]"
                                                        prepend-icon="mdi-airplane-landing"
                                                        clearable
                                                        @change="onChange_inputAirportDestination">
                                                        <template v-slot:label>
                                                            <p>
                                                                Airport Destination <span style="color: red; font-size: 1.4rem;">*</span>
                                                            </p>
                                                        </template>
                                                    </v-combobox>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_Blocktime"
                                                        prepend-icon="mdi-clock-time-four-outline"
                                                        :rules ="[
                                                            rules.req(input_Blocktime),
                                                        ]"
                                                        type="time">
                                                        <template v-slot:label>
                                                            <p>
                                                                Blocktime <span style="color: red; font-size: 1.4rem;">*</span>
                                                            </p>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-stepper-content>
                                <!-- <<< Stepper: 1 - 'BLocktime Config'        -->
                            </v-stepper>
                        </v-container>
                    </v-form>
                </v-card-text>
                <!-- <<< Stepper -->


                <!-- >>> Actions -->
                <v-card-actions>
                    <v-spacer />

                    <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet">
                    Close
                    </v-btn>
                    <v-btn style="width:120px" depressed elevation="1" color="primary" @click="onValidate_Form">
                    Save
                    </v-btn>
                </v-card-actions>
                <!-- <<< Actions -->
</v-card>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main';


    export default {
        name: 'BottomSheet',


        /* >>> *************************************************************** / /* Props */
        props: {

            value: [Boolean], // 'showSheet' itself
            editorMode: String, // 'update', 'create'
            blocktimePrefillObject: Object

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------ Input Fields
                input_ResourceId: null,
                input_AirportDeparture: null,
                input_AirportDestination: null,
                input_Blocktime: null,
                // >>> ------------------------------------ Validation
                formStepper: 1,
                valid: true,
                isValid_Stepper1: true,
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || 'Field is required';
                    }
                }
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Airports'
            ]),


            /*******************************************************************
            * sheetShown{}
            *
            * Desc:
            * Note:
            *
            */
            sheetShown: {

                get() {

                    const me = this;
                    const eventRecord = me.blocktimePrefillObject;


                    me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> computed/sheetShown/get');
                    if (me.value === true) { // we're opening so initialize data

                        // >>> ------------------ reset validation
                        if (me.$refs.form !== undefined) {
                            me.$refs.form.resetValidation();
                        }

                        // >>> ------------------ update
                        if (me.editorMode === 'update') {
                            if (eventRecord) {
                                me.onAssign_Update(eventRecord);
                            }
                        }

                        // >>> ------------------ create
                        if (me.editorMode === 'create') {
                            me.onAssign_Create();
                        }

                    }


                    return this.value;

                }, // eo function sheetShown get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> computed/sheetShown/set');
                    me.$emit('input', value);

                } // eo function sheetShown set()

            } // eo sheetShown{}

        }, // eo computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> created');
            eventBus.$on('blocktimewasupdatedcreated', this.onEmit_BlocktimeWasUpdatedCreated);


		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> destroyed');
            eventBus.$off('blocktimewasupdatedcreated', this.onEmit_BlocktimeWasUpdatedCreated);

		}, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_updateCreateBlocktimes'
            ]),


            /*******************************************************************
            * Listeners: Common
            *******************************************************************/
            /*******************************************************************
            * onValidate_Form{}
            *
            * Desc:
            * Note:
            *
            */
            onValidate_Form: function() {

                const me = this;
                let payload = null;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> onValidate_Form');
                me.validateFormStepper('1');
                if (me.$refs.form.validate() === true) {
                    payload = me.createPayload();
                    me.actn_call_updateCreateBlocktimes({ blockTimes: [payload] });
                }

            }, // eo function onValidate_Form()


            /*******************************************************************
            * onAssign_Create()
            *
            * Desc: Assign Object in/for 'create' Mode. (Reset)
            * Note:
            *
            */
            onAssign_Create: function() {

                const me = this;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> onAssign_Create');
                Object.assign(me, {
                    // >>> ------------------------------------ Input Fields
                    input_ResourceId: null,
                    input_AirportDeparture: null,
                    input_AirportDestination: null,
                    input_Blocktime: null,
                    // >>> ------------------------------------ Validation
                    formStepper: 1,
                    valid: true,
                    isValid_Stepper1: true
                });

            }, // eo function onAssign_Create()


            /******************************************************************* 'Assign -  Update/Create'
            * onAssign_Update()
            *
            * Desc: Assign Object in/for 'update' Mode.
            * Note: Airport Fields need to be updated, after setting.
            * Note: There is a whole object needed, not just the plain IATA Code
            * Note: String. (This could be done since we set these iata codes
            * Note: based on the backends answer.)
            *
            * @param {Object} eventRecord ()
            */
            onAssign_Update: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> onAssign_Update');
                Object.assign(me, {
                    // >>> General ------------------------
                    input_ResourceId: eventRecord.id,
                    input_AirportDeparture: me.get_Airports.find(airport => eventRecord.aptFromCode === airport.aptCode),
                    input_AirportDestination: me.get_Airports.find(airport => eventRecord.aptToCode === airport.aptCode),
                    input_Blocktime: eventRecord.blockTime,
                    // >>> ------------------------------------ 'Stepper Errors'
                    isValid_Stepper1: true,
                    valid: true,
                    activeStepper: '1'
                });

            }, // eo function onAssign_Update()


            /*******************************************************************
            * onChange_inputAirportDeparture()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_inputAirportDeparture: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> onChange_inputAirportDeparture');
                if (me.input_AirportDeparture === null) {
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.input_AirportDeparture !== 'object') {
                    airport = me.get_Airports.find(airport => airport.aptCode === me.input_AirportDeparture);
                } else {
                    airport = me.get_Airports.find(airport => airport.aptCode === me.input_AirportDeparture.aptCode);
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.input_AirportDeparture = airport;
                } else {
                    me.input_AirportDeparture = '';
                }

            }, // eo function onChange_inputAirportDeparture()


            /*******************************************************************
            * onChange_inputAirportDestination()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_inputAirportDestination: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> onChange_inputAirportDestination');
                if (me.input_AirportDestination === null) {
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.input_AirportDestination !== 'object') {
                    airport = me.get_Airports.find(airport => airport.aptCode === me.input_AirportDestination);
                } else {
                    airport = me.get_Airports.find(airport => airport.aptCode === me.input_AirportDestination.aptCode);
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.input_AirportDestination = airport;
                } else {
                    me.input_AirportDestination = '';
                }

            }, // eo function onChange_inputAirportDestination()


            /*******************************************************************
            * onEmit_BlocktimeWasUpdatedCreated{}
            *
            * Desc:
            * Note:
            *
            */
            onEmit_BlocktimeWasUpdatedCreated: function() {

                const me = this;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> onEmit_BlocktimeWasUpdatedCreated');
                me.onClick_CloseSheet();

            }, // eo function onEmit_BlocktimeWasUpdatedCreated{}


            /*******************************************************************
            * onClick_CloseSheet{}
            *
            * Desc:
            * Note:
            *
            */
            onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> onClick_CloseSheet');
                me.sheetShown = false;

            }, // eo function onClick_CloseSheet{}



            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * createPayload()
            *
            * Desc:
            * Note: id = null means create mode, id != null means update mode
            *
            * @returns {Object}
            */
            createPayload: function() {

                const me = this;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> createPayload');
                return {
                    id: me.input_ResourceId, // see Note
                    aptFromCode: me.input_AirportDeparture.aptCode,
                    aptToCode: me.input_AirportDestination.aptCode,
                    blockTime: me.input_Blocktime
                };

            }, // eof createPayload()




            /*******************************************************************
            * Listeners/ Utilities: Stepper Validation
            *******************************************************************/
            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc: Validate leaved Stepper Content, set new active Stepper.
            * Note: First validate the activeStepper, but only if it was
            * Note: validated as FALSE before.
            *
            * @param {Number} stepperNumber
            */
            onClick_StepperHeader: function(stepperNumber) {

                const me = this;


				me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> onClick_StepperHeader');
                switch (me.activeStepper) {
                    case '1':
                        if (me.isValid_Stepper1 === false) {
                            me.validateFormStepper('1');
                        }
                        break;
                    default: break;
                }

                me.activeStepper = stepperNumber;

            }, // eo function onClick_StepperHeader()


            /*******************************************************************
            * validateInputFields()
            *
            * Desc: Identify an element as INPUT.
            * Note: Check ELEMENT of being an input field.
            * Note: It is an input field if the key "type" exists in this
            * Note: object. ('type' in element)
            * Note: If this object does not have this "type" key, look up
            * Note: the children of this ELEMENT recursivly.
            *
            * @param {Object} element
            * @returns {Boolean}
            */
            validateInputFields: function(element) {

                const me = this;
                let valid = true;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> validateInputFields');
                if ('type' in element) { // ;-)
                    return element.valid !== undefined ? element.valid : true;
                } else {
                    if (element.$children.length > 0) {
                        element.$children.forEach(child => {
                            valid = valid && this.validateInputFields(child);
                        });
                    }
                }


                return valid;

            }, // eo function validateInputFields()


            /*******************************************************************
            * validateFormStepper()
            *
            * Desc: Validate a single Steppers inputs.
            * Note: Get all children of a Stepper with a ref.
            * Note: Loop over the children and identify them as input fields,
            * Note: after that check for the VALID key.
            *
            * @param {Number} stepperNumber
            * @returns {Boolean}
            */
            validateFormStepper: function(stepperNumber) {

                const me = this;
                let stepperIsValid = true,
                    child = null,
                    stepperRef = null;


                me.$toc('>>> views/flights/blocktimes/components/core/BottomSheet.vue >>> validateFormStepper');
                switch (stepperNumber) {
                    case '1':
                        stepperRef = this.$refs.stepperContent1;
                        break;
                    default:
                        stepperRef = null;
                        break;
                }


                if (stepperRef !== null) {
                    for (let i = 0; i < stepperRef.$children.length; i++) {
                        child = stepperRef.$children[i];

                        stepperIsValid = this.validateInputFields(child);
                        stepperIsValid = false;
                        break;
                    }
                }


                switch (stepperNumber) {
                    case '1':
                        me.isValid_Stepper1 = stepperIsValid;
                        break;
                    default:
                        break;
                }


                return stepperIsValid;

            } // eo function validateFormStepper()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>


<style>
    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        max-height:700px;
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }
</style>
